export default __webpack_public_path__ + "static/media/A0003.fa52e338.png";